import { useSelector } from "react-redux";
import { getCurrentWeekForUrl } from "../store/slices/time";
import useDraft from "./queryResults/draft/useDraft";
import useIsLoading from "./queryResults/useIsLoading";
import useLeagueSeason from "./queryResults/useLeagueSeason";
import useAdminMode from "./useAdminMode";

export default function useLeagueLinks() {
  const { leagueSeason, leagueQuery } = useLeagueSeason();
  const { draftData, draftQuery } = useDraft();
  const currentWeekForUrl = useSelector(getCurrentWeekForUrl);
  const adminMode = useAdminMode();

  const isLoading = useIsLoading(
    leagueSeason,
    leagueQuery,
    draftData,
    draftQuery
  );
  if (isLoading) return [];

  // todo: add checks for isError in isLoading
  if (leagueQuery.isError) {
    console.error(leagueQuery.error);
    return [];
  }

  const draftHasEnded = !!draftData.draft.endDate;

  const leagueSeasonPathNoWeek = leagueSeason.getPathNoWeek();
  const leagueSeasonPathWithWeek = leagueSeason.getPath({
    week: currentWeekForUrl,
  });

  const makeLink = (label, routeAfterBase = "", useWeek = true) => {
    const base = useWeek ? leagueSeasonPathWithWeek : leagueSeasonPathNoWeek;
    const route = `${base}${routeAfterBase}`;
    return { route, label };
  };

  const homeLink = makeLink("league home");
  const nflLink = makeLink("nfl", "/nfl", true);
  const adminLink = makeLink("admin", "/admin", false);
  const draftLink = makeLink(
    "draft",
    !!draftData.draft.endDate ? "/draft-results" : "/draft",
    false
  );
  const gamesLink = makeLink("games", "/all-games");
  const messageBoardLink = makeLink("message board", "/message-board", false);
  const playersLink = makeLink("players", "/players", false);
  const waiversLink = makeLink("waivers", "/waivers", false);
  // const powerRankingsLink = makeLink("power rankings", "/power-rankings");
  const standingsLink = makeLink("standings", "/standings");
  const transactionsLink = makeLink("transactions", "/transactions", false);

  let links = [nflLink, homeLink];

  if (adminMode) links.push(adminLink);

  if (!draftHasEnded) {
    links = links.concat([draftLink, gamesLink, messageBoardLink]);
  }

  if (draftHasEnded) {
    links = links.concat([
      gamesLink,
      standingsLink,
      playersLink,
      waiversLink,
      messageBoardLink,
      transactionsLink,
      draftLink,
    ]);
  }

  return links;
}
